__turbopack_context__.v({
  "insertPromptText": "ATfwEG_insertPromptText",
  "promptButton": "ATfwEG_promptButton",
  "selected": "ATfwEG_selected",
  "selectedNonInteractive": "ATfwEG_selectedNonInteractive",
  "textContainer": "ATfwEG_textContainer",
});
